import React, { useEffect, useMemo } from 'react'
import { Box } from '@mui/material'
import { UpdateGroup } from './UpdateGroup'
import BasicTabs, { BasicTabType } from '../../utility/Tabs'
import { Maintenance } from './Maintenance'
import { UrlCsvExport } from './UrlCsvExport'
import { WithAltText } from './WithAltText'
import { useAtomValue, useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { altTextTreeAtom, sortedTreeUrlsAtom } from './atoms'
import { useTreeGetter } from '../../../reducers/trees_hooks'
import { SourceTable } from './SourceTable'
import { ExportButton } from './exportButton'

// AltText - the container for all the alt text tools
// each tool is displayed in a tab
export function AltText({
  treeId,
  versionId,
}: {
  treeId: string
  versionId: string
}) {
  const getter = useTreeGetter()
  const treeSetter = useSetAtom(altTextTreeAtom)
  const { withoutAltText, withAltText } = useAtomValue(sortedTreeUrlsAtom)

  useEffect(() => {
    treeSetter(getter({ treeId, versionId }))
  }, [treeSetter, getter, treeId, versionId])

  const tabs: BasicTabType[] = useMemo(() => {
    return [
      ['Alt Text Source', SourceTable],
      ['Updates', UpdateGroup],
      [`Without Alt Text: ${withoutAltText.length}`, UrlCsvExport],
      [`With Alt Text: ${withAltText.length}`, WithAltText],
      ['Maintenance', Maintenance],
    ]
  }, [withAltText.length, withoutAltText.length])

  return (
    <Box>
      <Box>
        <ExportButton />
      </Box>
      <BasicTabs tabComponents={tabs} />
    </Box>
  )
}
